let selectedProducts = [];
let freeGiftProduct = null;
let freeGiftVariants = [];
const contentInner = document.getElementById('content-inner');

/* ---------- NEW: helpers for the Add-to-Cart button ---------- */
function getItemCount() {
    let count = selectedProducts.reduce((sum, product) => sum + (product.quantity || 0), 0);
    
    // Add free gift if unlocked AND a color is selected
    const discountedTotal = getDiscountedSubtotal();
    const freeGiftSelector = document.getElementById('free-gift-selector');
    if (discountedTotal >= 100 && freeGiftSelector && freeGiftSelector.value && freeGiftSelector.value !== '') {
        count += 1;
    }
    
    return count;
}

function updateAddButtonLabel() {
    const buttonContent = document.getElementById('button-content');
    if (!buttonContent) return;
    
    const count = getItemCount();
    const discountedTotal = getDiscountedSubtotal();
    
    if (count > 0) {
        buttonContent.innerHTML = `$${discountedTotal.toFixed(2)} | Add ${count} to Cart`;
        document.getElementById('add-bundle-to-cart').disabled = false;
    } else {
        buttonContent.textContent = 'Add to Cart';
        document.getElementById('add-bundle-to-cart').disabled = true;
    }
}
/* ------------------------------------------------------------- */

/* ---------- NEW: Free Gift Functions ---------- */
async function fetchFreeGiftProduct() {
    try {
        console.log('Fetching free gift product...');
        const response = await fetch('/products/belt-bag.js');
        if (!response.ok) {
            console.log('Trying alternative product fetch method...');
            // Try with product ID in different format
            const altResponse = await fetch(`/products.json?ids=${8297393029274}`);
            if (!altResponse.ok) {
                throw new Error(`HTTP error! status: ${altResponse.status}`);
            }
            const altData = await altResponse.json();
            if (altData.products && altData.products.length > 0) {
                const product = altData.products[0];
                console.log('Free gift product fetched via alternative method:', product);
                freeGiftProduct = product;
                freeGiftVariants = product.variants;
                renderFreeGiftSection();
                return;
            }
            throw new Error('Product not found in alternative fetch');
        }
        const product = await response.json();
        console.log('Free gift product fetched:', product);
        freeGiftProduct = product;
        freeGiftVariants = product.variants;
        renderFreeGiftSection();
    } catch (error) {
        console.error('Error fetching free gift product:', error);
        // Try one more method - using the variant API directly
        try {
            console.log('Trying variant-based fetch...');
            const variantResponse = await fetch('/products.json?limit=250');
            const allProducts = await variantResponse.json();
            const targetProduct = allProducts.products.find(p => p.id == 8297393029274);
            
            if (targetProduct) {
                console.log('Found product via products.json:', targetProduct);
                freeGiftProduct = targetProduct;
                freeGiftVariants = targetProduct.variants;
                renderFreeGiftSection();
                return;
            }
        } catch (secondError) {
            console.error('Second fetch attempt failed:', secondError);
        }
        
        // Final fallback: manual product data
        console.log('Using manual fallback for free gift');
        createManualFreeGiftSection();
    }
}

function calculateBundleTotal() {
    let total = 0;
    for (const product of selectedProducts) {
        total += (Number(window.igData?.price?.getPriceByVariantId(product.variantId)) || (parseFloat(product.variantPrice) / 100)) * product.quantity;
    }
    return total;
}

/* ---------- NEW: AFTER-discount subtotal helper (in dollars) ---------- */
function getDiscountedSubtotal() {
    const grossTotal = calculateBundleTotal();   // dollars
    const savingsCents = calculateB2G1Savings(); // cents (B2G1 only, no free gift)
    const net = grossTotal - (savingsCents / 100);
    return Math.max(0, Number(net.toFixed(2)));
}
/* --------------------------------------------------------------------- */

function updateFreeGiftStatus() {
    const subtotal = getDiscountedSubtotal(); // dollars AFTER B2G1
    const freeGiftSection = document.getElementById('free-gift-section');
    const freeGiftSelector = document.getElementById('free-gift-selector');
    const unlockText = document.getElementById('free-gift-unlock-text');
    
    if (!freeGiftSection) {
        console.log('Free gift section not found!');
        return;
    }
    
    console.log('Updating free gift status. Subtotal:', subtotal);
    
    if (subtotal >= 100) {
        // Unlock the free gift
        console.log('Unlocking free gift');
        freeGiftSection.classList.remove('locked');
        freeGiftSection.classList.add('unlocked');
        if (freeGiftSelector) {
            freeGiftSelector.disabled = false;
            freeGiftSelector.style.display = 'block';
        }
        if (unlockText) unlockText.style.display = 'none';
    } else {
        // Lock the free gift
        console.log('Locking free gift');
        freeGiftSection.classList.remove('unlocked');
        freeGiftSection.classList.add('locked');
        if (freeGiftSelector) {
            freeGiftSelector.disabled = true;
            freeGiftSelector.style.display = 'none';
            // Reset selection when locked
            freeGiftSelector.value = '';
        }
        if (unlockText) unlockText.style.display = 'block';
    }
    
    // Update savings and button label
    calculateSavings();
    updateAddButtonLabel();
}

function handleFreeGiftSelection(variantId) {
    const variant = freeGiftVariants.find(v => v.id == variantId);
    if (!variant) return;
    
    const freeGiftImage = document.getElementById('free-gift-image');
    if (freeGiftImage && variant.featured_image) {
        freeGiftImage.src = variant.featured_image.src;
        freeGiftImage.alt = variant.title;
    }
}

function renderFreeGiftSection() {
    console.log('Rendering free gift section...');
    if (!freeGiftProduct) return;

    const freeGiftContainer = document.getElementById('free-gift-container');
    if (!freeGiftContainer) {
        console.error('Free gift container not found!');
        return;
    }

    const variantOptions = freeGiftVariants.map(variant =>
        `<option value="${variant.id}">${variant.title}</option>`
    ).join('');

    // Robustly resolve an image URL from product/variant JSON, else use your fallback
    const FALLBACK_IMG = "https://braxleybands.com/cdn/shop/files/Gray_Front.webp?v=1726155976&width=800";
    let defaultImageSrc = "";

    const pickSrc = (val) => {
        if (!val) return "";
        if (typeof val === "string") return val;
        if (typeof val.src === "string") return val.src;
        return "";
    };

    // Try product.featured_image (string or object)
    defaultImageSrc = pickSrc(freeGiftProduct.featured_image);

    // Then try product.image or first product.images
    if (!defaultImageSrc) defaultImageSrc = pickSrc(freeGiftProduct.image);
    if (!defaultImageSrc && Array.isArray(freeGiftProduct.images) && freeGiftProduct.images.length) {
        defaultImageSrc = pickSrc(freeGiftProduct.images[0]);
    }

    // Then try first variant image
    if (!defaultImageSrc && freeGiftVariants && freeGiftVariants.length) {
        const v0 = freeGiftVariants[0];
        defaultImageSrc = pickSrc(v0.featured_image) || pickSrc(v0.image);
    }

    // Finally, your provided fallback
    if (!defaultImageSrc) defaultImageSrc = FALLBACK_IMG;

    freeGiftContainer.innerHTML = `
        <div id="free-gift-section" class="free-gift-section locked">
            <div class="free-gift-content">
                <div class="free-gift-image-container">
                    <img id="free-gift-image" src="${defaultImageSrc}" alt="${freeGiftProduct.title}" class="free-gift-image">
                    <div class="free-gift-overlay">
                        <svg class="lock-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#000000" fill-rule="evenodd" d="M3 12a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-7zm10 2a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3z" clip-rule="evenodd"/><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10V7a4 4 0 0 1 4-4v0a4 4 0 0 1 4 4v3"/></svg>
                    </div>
                </div>
                <div class="free-gift-details">
                    <h4 class="free-gift-name">
                        <span>${freeGiftProduct.title}</span>
                        <span id="free-gift-price" class="free-gift-price"><s>$54.99</s> FREE</span>
                    </h4>
                    <div id="free-gift-unlock-text" style="display: block; font-size: 14px; color: #000000; padding: 3px 0px 3px 3px;">Free Gift Unlocked at $100</div>
                    <select id="free-gift-selector" class="free-gift-selector" onchange="handleFreeGiftSelection(this.value)" disabled>
                        <option value="">Select color</option>
                        ${variantOptions}
                    </select>
                </div>
            </div>
        </div>
    `;

    console.log('Free gift section rendered');
    updateFreeGiftStatus();
}


function createManualFreeGiftSection() {
    console.log('Creating manual free gift section...');
    const freeGiftContainer = document.getElementById('free-gift-container');
    if (!freeGiftContainer) {
        console.error('Free gift container not found!');
        return;
    }

    const FALLBACK_IMG = "https://braxleybands.com/cdn/shop/files/Gray_Front.webp?v=1726155976&width=800";

    freeGiftContainer.innerHTML = `
        <div id="free-gift-section" class="free-gift-section locked">
            <div class="free-gift-header">
                <h3 id="free-gift-title">Add $100.00 more to unlock your free gift!</h3>
            </div>
            <div class="free-gift-content">
                <div class="free-gift-image-container">
                    <img id="free-gift-image" src="${FALLBACK_IMG}" alt="Free Gift Bag" class="free-gift-image">
                    <div class="free-gift-overlay">
                        <svg class="lock-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#000000" fill-rule="evenodd" d="M3 12a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-7zm10 2a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3z" clip-rule="evenodd"/><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10V7a4 4 0 0 1 4-4v0a4 4 0 0 1 4 4v3"/></svg>
                    </div>
                </div>
                <div class="free-gift-details">
                    <h4 class="free-gift-name">
                        <span>Free Gift Bag</span>
                        <span id="free-gift-price" class="free-gift-price"><s>$54.99</s> FREE</span>
                    </h4>
                    <div id="free-gift-unlock-text" style="display: block; font-size: 14px; color: #666;">Free Gift Unlocked at $100</div>
                    <select id="free-gift-selector" class="free-gift-selector" onchange="handleManualFreeGiftSelection(this.value)" disabled>
                        <option value="">Select color</option>
                        <option value="manual-black">Black</option>
                        <option value="manual-white">White</option>
                        <option value="manual-brown">Brown</option>
                        <option value="manual-navy">Navy</option>
                    </select>
                </div>
            </div>
        </div>
    `;

    console.log('Manual free gift section created');
    updateFreeGiftStatus();
}

function handleFreeGiftSelection(variantId) {
    if (variantId && variantId !== '') {
        // Color selected - update image
        const variant = freeGiftVariants.find(v => v.id == variantId);
        if (variant) {
            const imgSrc =
                (variant.featured_image && (typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src)) ||
                (variant.image && (typeof variant.image === 'string' ? variant.image : variant.image.src)) ||
                "";

            const freeGiftImage = document.getElementById('free-gift-image');
            if (freeGiftImage && imgSrc) {
                freeGiftImage.src = imgSrc;
                freeGiftImage.alt = variant.title;
            }
        }
    } else {
        // No color selected (back to "Select color") - reset to default image
        const freeGiftImage = document.getElementById('free-gift-image');
        if (freeGiftImage && freeGiftProduct) {
            // Reset to default product image
            const FALLBACK_IMG = "https://braxleybands.com/cdn/shop/files/Gray_Front.webp?v=1726155976&width=800";
            let defaultImageSrc = "";

            const pickSrc = (val) => {
                if (!val) return "";
                if (typeof val === "string") return val;
                if (typeof val.src === "string") return val.src;
                return "";
            };

            // Try product.featured_image (string or object)
            defaultImageSrc = pickSrc(freeGiftProduct.featured_image);

            // Then try product.image or first product.images
            if (!defaultImageSrc) defaultImageSrc = pickSrc(freeGiftProduct.image);
            if (!defaultImageSrc && Array.isArray(freeGiftProduct.images) && freeGiftProduct.images.length) {
                defaultImageSrc = pickSrc(freeGiftProduct.images[0]);
            }

            // Then try first variant image
            if (!defaultImageSrc && freeGiftVariants && freeGiftVariants.length) {
                const v0 = freeGiftVariants[0];
                defaultImageSrc = pickSrc(v0.featured_image) || pickSrc(v0.image);
            }

            // Finally, fallback
            if (!defaultImageSrc) defaultImageSrc = FALLBACK_IMG;

            freeGiftImage.src = defaultImageSrc;
            freeGiftImage.alt = freeGiftProduct.title;
        }
    }
    
    // Update savings when selection changes
    calculateSavings();
    
    // Update button label when free gift selection changes
    updateAddButtonLabel();
}
/* ------------------------------------------------ */

async function fetchProductByVariantId(variantId) {
    const response = await fetch(`/variants/${variantId}.js`);
    const variant = await response.json();
    return variant;
}

function updateBundleMeter() {
    const progress = document.getElementById('bundle-progress');
    const offerText = document.getElementById('bundle-offer');
    const freeShippingText = document.getElementById('free-shipping-text');
    const itemCount = selectedProducts.reduce((sum, product) => sum + product.quantity, 0);

    // Show "free shipping" whenever there's 1+ items
    if (freeShippingText) {
        // If your element should be block-level, keep 'block'. If it's a flex item, use 'flex'.
        freeShippingText.style.display = itemCount > 1 ? 'block' : 'none';
    }

    // Get the previous count from a stored value, not calculated
    const previousCount = window.previousItemCount || 0;
    window.previousItemCount = itemCount;

    // Calculate remaining amount needed for free gift
    const discountedTotal = getDiscountedSubtotal();
    const remainingForGift = Math.max(0, 100 - discountedTotal);

    // Update progress bar and offer text
    if (itemCount >= 3) {
    if (progress) progress.style.width = '100%';
    if (offerText) {
        const offerSpan = offerText.querySelector('span');
        offerSpan.textContent = remainingForGift > 0
          ? 'Your Bundle is complete!'
          : 'Select Your Free Gift Color!';
    }

    // Only trigger effects when crossing the threshold of a multiple of 3 AND increasing
    if (itemCount % 3 === 0 && previousCount % 3 !== 0 && itemCount > previousCount) {
        // Always expand (desktop + mobile)
        showBundleContent();

        // Confetti only on mobile
        if (window.innerWidth <= 767) {
            celebrateCompletion();
        }
    }

    } else if (itemCount === 2) {
        if (progress) progress.style.width = '85%';
        if (offerText) {
            const offerSpan = offerText.querySelector('span');
            offerSpan.textContent = 'Add your free band!';
        }
    } else if (itemCount === 1) {
        if (progress) progress.style.width = '50%';
        if (offerText) {
            const offerSpan = offerText.querySelector('span');
            offerSpan.textContent = 'Add 1 more and get 1 free!';
        }
    } else {
        if (progress) progress.style.width = '0%';
        if (offerText) {
            const offerSpan = offerText.querySelector('span');
            offerSpan.textContent = 'Buy 2 and get 1 free!';
        }
    }

    // Update totals
    calculateTotalPrice();
    calculateSavings();
    updatePriceDisplay();

    // Apple Watch giveaway entries — driven by post-B2G1 subtotal
    if (window.updateGiveawayEntries) window.updateGiveawayEntries(getDiscountedSubtotal());

    // Make sure free gift status is updated
    updateFreeGiftStatus();

    // Ensure the Add button reflects the current count
    updateAddButtonLabel();
}


function celebrateCompletion() {
    confetti({
        particleCount: 250,
        spread: 70,
        origin: { x: 0.5, y: 1.1 }, // Slightly below screen bottom
        gravity: 0.8,
        colors: ['#6cacbe', '#ffb078', '#feb078', '#caffd1', '#e1c0ff'],
        zIndex: 1000
    });
}

function calculateB2G1Savings() {
    let totalSavings = 0;
    const totalItems = selectedProducts.reduce((sum, product) => sum + product.quantity, 0);
    const freeItems = Math.floor(totalItems / 3);
    
    if (freeItems > 0) {
        // Sort products by price to get the cheapest ones first
        const sortedProducts = [...selectedProducts].sort((a, b) => 
            parseFloat(a.variantPrice) - parseFloat(b.variantPrice)
        );
        
        let remainingFreeItems = freeItems;
        for (const product of sortedProducts) {
            const freeQuantity = Math.min(remainingFreeItems, product.quantity);
            if (freeQuantity > 0) {
                totalSavings += ((Number(window.igData?.price?.getPriceByVariantId(product.variantId)) || (parseFloat(product.variantPrice) / 100))) * freeQuantity;
                remainingFreeItems -= freeQuantity;
            }
            if (remainingFreeItems === 0) break;
        }
    }
    
    return totalSavings * 100; // Return in cents
}

function calculateSavings() {
    // Start with B2G1 savings
    let totalSavings = calculateB2G1Savings() / 100; // Convert back to dollars
    
    // Add free gift savings if unlocked and selected
    const discountedTotal = getDiscountedSubtotal();
    const freeGiftSelector = document.getElementById('free-gift-selector');
    if (discountedTotal >= 100 && freeGiftSelector && freeGiftSelector.value && freeGiftSelector.value !== '') {
        // Add the free gift price to savings (assuming $25 for the belt bag)
        totalSavings += 54.99; // You can adjust this to the actual product price
    }
    
    document.getElementById('bundle-savings').textContent = `$${totalSavings.toFixed(2)}`;
    return totalSavings * 100; // Return in cents for consistency
}

function updatePriceDisplay() {
    const totalItems = selectedProducts.reduce((sum, product) => sum + product.quantity, 0);
    const freeItems = Math.floor(totalItems / 3);
    
    const sortedProducts = [...selectedProducts].sort((a, b) => 
        parseFloat(a.variantPrice) - parseFloat(b.variantPrice)
    );
    
    selectedProducts.forEach(product => {
        const priceElement = document.querySelector(`#product-${product.variantId} .item-price`);
        if (priceElement) {
            priceElement.textContent = `$${(Number(window.igData?.price?.getPriceByVariantId(product.variantId)) || (product.variantPrice / 100)).toFixed(2)}`;
            priceElement.style.textDecoration = 'none';
        }
    });
    
    if (freeItems > 0) {
        let remainingFreeItems = freeItems;
        for (const product of sortedProducts) {
            const freeQuantity = Math.min(remainingFreeItems, product.quantity);
            if (freeQuantity > 0) {
                const priceElement = document.querySelector(`#product-${product.variantId} .item-price`);
                if (priceElement) {
                    if (freeQuantity === product.quantity) {
                        // If all quantities are free, show strikethrough and FREE!
                        priceElement.innerHTML = `<s>$${(Number(window.igData?.price?.getPriceByVariantId(product.variantId)) || (product.variantPrice / 100)).toFixed(2)}</s> <span class="free-text">FREE</span>`;
                    } else {
                        // If only some quantities are free, show regular price for paid items and FREE! for free items
                        priceElement.innerHTML = `${product.quantity - freeQuantity} X $${(Number(window.igData?.price?.getPriceByVariantId(product.variantId)) || (product.variantPrice / 100)).toFixed(2)}, <span class="free-text">${freeQuantity} FREE</span>`;
                    }
                }
                remainingFreeItems -= freeQuantity;
            }
            if (remainingFreeItems === 0) break;
        }
    }
}

function renderProduct(product) {
    const productTitle = product.title;
    const featuredImageUrl = product.imageUrl;
    const quantity = product.quantity;
    const VariantTitle = product.variantTitle;
    const VariantPrice = Number(window.igData?.price?.getPriceByVariantId(product.variantId)) || product.variantPrice;
    
    document.getElementById("noproduct").style.display = 'none';

    const itemHtml = `
        <div class="atc-item" id="product-${product.variantId}">
            <img
                class="atc-item-image"
                width="60px"
                height="60px"
                src="${featuredImageUrl}"
                alt="${productTitle}"
            >
            <div class="atc-item-inner">
                <div class="item-info">
                    <span class="item-title">${productTitle}</span>
                    <span class="item-variant">${VariantTitle}</span>
                </div>
                <div class="bundle-cart-right">
                    <span class="item-price">$${(VariantPrice / 100).toFixed(2)}</span>
                    <div class="bundle-quantifier">
                        <a onclick="handleDecreaseQuantity('${product.variantId}')" class="clear-cart">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                <title>minus</title>
                                <path d="M436 284c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h424z"/>
                            </svg>
                        </a>
                        <span class="atc-quantity" id="quantity-${product.variantId}">${quantity}</span>
                        <a onclick="handleIncreaseQuantity('${product.variantId}')" class="clear-cart">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                <title>plus</title>
                                <path d="M436 228H252V44c0-6.6-5.4-12-12-12h-32c-6.6 0-12 5.4-12 12v184H12c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h184v184c6.6 0 12-5.4 12-12V284h184c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12z"/>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    `;
    contentInner.insertAdjacentHTML('beforeend', itemHtml);
    updateBundleMeter();
}

function updateProductQuantity(variantId, quantity) {
    const quantityElement = document.getElementById(`quantity-${variantId}`);
    if (quantityElement) {
        quantityElement.textContent = quantity;
    }
    updateBundleMeter();
}

function handleDecreaseQuantity(variantId) {
    const productIndex = selectedProducts.findIndex(product => product.variantId === variantId);
    if (productIndex !== -1) {
        selectedProducts[productIndex].quantity -= 1;
        if (selectedProducts[productIndex].quantity <= 0) {
            // Remove the product from the array
            selectedProducts.splice(productIndex, 1);
            // Remove the product element from DOM
            const productElement = document.getElementById(`product-${variantId}`);
            if (productElement) {
                productElement.remove();
                if (selectedProducts.length === 0) {
                    document.getElementById("noproduct").style.display = 'block';
                    const button = document.getElementById('add-bundle-to-cart');
                    button.disabled = true;
                }
            }
        } else {
            updateProductQuantity(variantId, selectedProducts[productIndex].quantity);
        }
        // Update UI after removal
        updateBundleMeter();
    }
    updateAllUI();
}

function handleIncreaseQuantity(variantId) {
    const productIndex = selectedProducts.findIndex(product => product.variantId === variantId);
    if (productIndex !== -1) {
        selectedProducts[productIndex].quantity += 1;
        updateProductQuantity(variantId, selectedProducts[productIndex].quantity);
    }
    updateAllUI();
}

function bundle(myvariant) {
    const selector = document.getElementById(myvariant);
    const option = selector.options[selector.selectedIndex];
    const variantId = selector.value;
    const productIndex = selectedProducts.findIndex(product => product.variantId === variantId);

    var title = selector.getAttribute("data-product-title");
    var img = selector.getAttribute("data-product-img");
    var variantTitle = option.getAttribute("data-variant-title");
    var variantPrice = option.getAttribute("data-variant-price");

    const button = document.getElementById('add-bundle-to-cart');
    button.disabled = false;

    // Find the form (thumbnail)
    const form = selector.closest("form.build-bundle");
    const addBtn = form.querySelector(".add_to_bundle");
    const qtyControls = form.querySelector(".bundle-qty-controls");
    const qtyInput = form.querySelector(".bundle-qty-input");

    if (productIndex !== -1) {
        // Already in bundle → increase quantity
        selectedProducts[productIndex].quantity += 1;
        updateProductQuantity(variantId, selectedProducts[productIndex].quantity);

        // Update input in UI
        if (qtyInput) qtyInput.value = selectedProducts[productIndex].quantity;

    } else {
        // New product → add to bundle
        const newProduct = {
            variantId,
            variantTitle,
            variantPrice,
            title,
            imageUrl: img,
            quantity: 1
        };

        // Capture line item properties (e.g., Pre-Order)
        const propertyInputs = form.querySelectorAll('input[name^="properties["]');
        if (propertyInputs.length > 0) {
            newProduct.properties = {};
            propertyInputs.forEach(input => {
                const key = input.name.replace('properties[', '').replace(']', '');
                newProduct.properties[key] = input.value;
            });
        }

        selectedProducts.push(newProduct);
        renderProduct(newProduct);

        // Switch UI to show controls
        if (addBtn && qtyControls && qtyInput) {
            addBtn.classList.add("hide");
            qtyControls.classList.remove("hidden");
            qtyInput.value = 1;
        }
    }
    updateAllUI();
    return false;
}

function handleThumbnailIncrease(form) {
    const selector = form.querySelector("select");
    const variantId = selector.value;
    const qtyInput = form.querySelector(".bundle-qty-input");

    handleIncreaseQuantity(variantId); // reuse existing
    const product = selectedProducts.find(p => p.variantId === variantId);
    if (product && qtyInput) qtyInput.value = product.quantity;
}

function handleThumbnailDecrease(form) {
    const selector = form.querySelector("select");
    const variantId = selector.value;
    const qtyInput = form.querySelector(".bundle-qty-input");
    const addBtn = form.querySelector(".add_to_bundle");
    const qtyControls = form.querySelector(".bundle-qty-controls");

    handleDecreaseQuantity(variantId); // reuse existing
    const product = selectedProducts.find(p => p.variantId === variantId);

    if (product) {
        if (qtyInput) qtyInput.value = product.quantity;
    } else {
        // Product was removed → show back Add button
        qtyControls.classList.add("hidden");
        addBtn.classList.remove("hide");
        if (qtyInput) qtyInput.value = 0;
    }
}

function updateAllUI() {
    // Update bundle meter (also updates totals/prices)
    updateBundleMeter();

    // Update all quantity inputs and product displays
    selectedProducts.forEach(product => {
        updateProductQuantity(product.variantId, product.quantity);
    });

    // Update all thumbnail forms - this is where we handle the 0 quantity case
    const forms = document.querySelectorAll("form.build-bundle");
    forms.forEach(form => {
        const selector = form.querySelector("select");
        const variantId = selector.value;
        const product = selectedProducts.find(p => p.variantId === variantId);
        const qtyInput = form.querySelector(".bundle-qty-input");
        const addBtn = form.querySelector(".add_to_bundle");
        const qtyControls = form.querySelector(".bundle-qty-controls");
        
        if (product && product.quantity > 0) {
            // Product exists and has quantity > 0 - show quantity controls
            if (qtyInput) qtyInput.value = product.quantity;
            if (addBtn) addBtn.classList.add("hide");
            if (qtyControls) qtyControls.classList.remove("hidden");
        } else {
            // Product doesn't exist or quantity is 0 - show Add button
            if (qtyInput) qtyInput.value = 0;
            if (addBtn) addBtn.classList.remove("hide");
            if (qtyControls) qtyControls.classList.add("hidden");
        }
    });

    // Handle empty cart state
    if (selectedProducts.length === 0) {
        document.getElementById("noproduct").style.display = 'block';
        document.getElementById('add-bundle-to-cart').disabled = true;
    } else {
        document.getElementById("noproduct").style.display = 'none';
        document.getElementById('add-bundle-to-cart').disabled = false;
    }

    /* NEW: ensure the Add button label matches current count */
    updateAddButtonLabel();
}

function calculateTotalPrice() {
    let totalPrice = 0;
    let savings = calculateSavings(); // This now includes free gift savings

    for (const product of selectedProducts) {
        totalPrice += (Number(window.igData?.price?.getPriceByVariantId(product.variantId)) || (parseFloat(product.variantPrice) / 100)) * product.quantity;
    }

    totalPrice -= savings / 100;
    
    // No longer updating sticky-atc-total since it's now in the button
}

/* ---------- v5.8.9 native cart: the bundle goes to the cart in ONE request (blueprint §4.11) ----------
   Bands and the free Stash Bag share one /cart/add.js call, so Shopify prices them together and no
   gift rule can run between "bag added" and "bands added". With the native cart the call is queued
   and the bag check reads the cart inside that job, so two quick calls cannot both add a bag.
   Only an ok result resets the builder; any failure keeps the bundle and shows why. */
let bbBundleInFlight = false;

async function atc_bundle() {
    if (bbBundleInFlight || !selectedProducts.length) return; // re-entry guard for the onclick button
    const btn = document.getElementById('add-bundle-to-cart');
    bbBundleInFlight = true;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    try {
        const oldError = document.getElementById('bb-bundle-error');
        if (oldError) oldError.remove();
        const bands = selectedProducts.map(p => ({ id: p.variantId, quantity: p.quantity, ...(p.properties ? { properties: p.properties } : {}) }));
        const sel = document.getElementById('free-gift-selector');
        const gift = (getDiscountedSubtotal() >= 100 && sel && sel.value && !sel.value.startsWith('manual-'))
            ? { id: Number(sel.value), quantity: 1, properties: { _free_gift: 'true' } } : null;
        const res = window.BBCart
            ? await window.BBCart.add(s => (gift && !(s && s.gift && s.gift.hasProductLine)) ? bands.concat(gift) : bands, // read inside the queued job
                                      { source: 'bundle-builder', retryMissing: true })
            : await bbFallbackAdd(gift ? bands.concat(gift) : bands);
        if (res && res.ok) {
            // Clear the bundle and update UI
            selectedProducts = [];
            contentInner.innerHTML = '<span id="noproduct" style="display: block; text-align: center;">Bundle added to cart!</span>';
            updateBundleMeter();
            updateAddButtonLabel();

            // Reset free gift selector
            const freeGiftSelector = document.getElementById('free-gift-selector');
            if (freeGiftSelector) {
                freeGiftSelector.value = '';
            }

            // Update all thumbnail forms to reset state
            updateAllUI();
        } else {
            // Keep the bundle (list and selection) so the shopper can try again; the message sits above the list.
            contentInner.insertAdjacentHTML('afterbegin', '<span id="bb-bundle-error" role="alert" style="display: block; text-align: center; margin: 10px 0 5px;"></span>');
            document.getElementById('bb-bundle-error').textContent = (res && res.message) || 'That could not be added. Please try again.';
        }
    } finally {
        bbBundleInFlight = false;
        if (btn) btn.removeAttribute('aria-busy');
        updateAddButtonLabel(); // recomputes disabled from the selection
    }
}

/* No native cart on the page (switched off): one plain Ajax Cart API call. Never throws. */
async function bbFallbackAdd(items) {
    try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
        });
        if (response.ok) return { ok: true };
        let message = '';
        try { message = (await response.json()).description || ''; } catch (e) { /* 429 HTML page */ }
        return { ok: false, status: response.status, message };
    } catch (error) {
        return { ok: false, status: 0, message: '' };
    }
}

// NEW: initialize button label on load
updateAddButtonLabel();

// Initialize free gift functionality when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchFreeGiftProduct);
} else {
    fetchFreeGiftProduct();
}

const buttons = document.querySelectorAll('.variant-button');
const popup = document.getElementById('variant-popup');
const productName = document.getElementById('product-name');
const variantIdField = document.getElementById('variant-id');

buttons.forEach(button => {
    button.addEventListener('click', function () {
        const name = this.dataset.variantTitle || this.dataset.productTitle;
        const variantId = this.dataset.variantId;
        
        productName.innerText = name;
        variantIdField.value = variantId;
        popup.style.display = 'block';
    });
});